import { timeline } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <SectionHeading
              label="Timeline"
              title="事件时间线：来龙去脉按顺序排好"
              desc="从话题第一次冒头到最新一次回应，黑料网吃瓜事件按发生顺序往下走，不再被零散信息带着跑。"
            />
            <span className="text-sm text-foreground-500 whitespace-nowrap">共 6 个节点 · 持续回填</span>
          </div>

          <ol className="mt-10 relative max-w-3xl">
            <span className="absolute left-[6px] -translate-x-1/2 top-2 bottom-2 w-px bg-background-300"></span>
            {timeline.map((item) => (
              <li key={item.title} className="relative pl-8 md:pl-10 pb-8 last:pb-0">
                <span className="absolute left-0 top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></span>
                <div className="flex flex-wrap items-center gap-3 mb-1.5">
                  <span className="text-xs text-foreground-500 tabular-nums">{item.date}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 whitespace-nowrap">
                    {item.status}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed max-w-2xl">{item.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}